export const CCtaBlockFragment = `
  fragment ctaBlock on ctaBlock_MatrixField {
    ... on ctaBlock_block_Entry {
      heading
      button {
        type
        url
        text
        target
      }
    }
  }
`
